/**
 * Safari reuses a cached non-CORS response (from a plain <img>) for CORS
 * requests to the same URL; S3 omits CORS headers on it, so the load fails.
 * A distinct query param gives CORS loads their own cache entry.
 */
export function withCorsCacheKey(url) {
    if (!url) return url;
    // Extra params would break a presigned URL's signature.
    if (/[?&]X-Amz-Signature=/i.test(url)) return url;
    // Not `cors`: that's an S3 subresource (GetBucketCors) and returns 403 on objects.
    return `${url}${url.includes('?') ? '&' : '?'}crossorigin=1`;
}
